import { axiosClient } from "./axiosClient"

export const PATTERN_PATH = '/api/v1/pattern'

export const addPattern = (body) => {
    return axiosClient.post(PATTERN_PATH, body)
}

export const updatePattern = (id, body) => {
    return axiosClient.put(`${PATTERN_PATH}/${id}`, body)
}

export const deletePattern = (id) => {
    return axiosClient.delete(`${PATTERN_PATH}/${id}`)
}

export const getPatternById = (id) => {
    return axiosClient.get(`${PATTERN_PATH}/${id}`)
}

export const getPagePatterns = ({ page = 0, size = 20, search = '', lastId = '', id = "", code = '', name = '' }) => {
    return axiosClient.get(`${PATTERN_PATH}/page?page=${page}&size=${size}&search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
}

export const uploadPatternExcelFile = (body) => {
    return axiosClient.post(`${PATTERN_PATH}/upload-excel`, body)
}

export const downloadPatternExcelFile = () => {
    return axiosClient.get(`${PATTERN_PATH}/download-excel`, {
        responseType: 'arraybuffer',
    })
}